module.exports = __webpack_public_path__ + "img/testimonials-2.f3c0271e.jpg";